// extracted by mini-css-extract-plugin
export default {"PrimaryNav":"primaryNav_PrimaryNav__11fdS","Icon":"primaryNav_Icon__wGoN6","Links":"primaryNav_Links__qEOT1","Highlight":"primaryNav_Highlight__TFHwt"};